import { palette } from '../colors';
import { pxToRem } from '../utils';

export const getMuiAlert = (rootHtmlFontSize = 16) => ({
    styleOverrides: {
        root: {
            padding: '16px',
            fontSize: pxToRem(16, rootHtmlFontSize),
            fontWeight: 400,
            lineHeight: '24px',
            maxWidth: '545px',
            '.MuiAlert-message': {
                padding: 0,
            },
            '.MuiAlertTitle-root': {
                color: 'inherit',
                fontWeight: 600,
            },
            '.MuiAlert-icon': {
                padding: 0,
            },
            variants: [
                {
                    props: { severity: 'success' },
                    style: {
                        color: palette.text?.success,
                    },
                },
                {
                    props: { severity: 'warning' },
                    style: {
                        color: palette.text?.warning,
                    },
                },
                {
                    props: { severity: 'error' },
                    style: {
                        color: palette.text?.error,
                    },
                },
                {
                    props: { severity: 'info' },
                    style: {
                        color: palette.text?.information,
                    },
                },
                {
                    props: { severity: 'ai' },
                    style: {
                        color: palette.text?.ai,
                        backgroundColor: palette.background?.ai,
                    },
                },
            ],
        },
    },
});
